import { gql } from '@apollo/client';

export default gql`
  fragment CourseChallengeFields on CourseChallenge {
    __typename
    id
    number
  }
`;
